import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import Accordion from '../../../../common/accordion';
import RolAccess from '../../../rolAccess';
import DisplayTextWithConditionalModal from '../../../displayTextWithConditionalModal';

import { TEXT_DISPLAY_LIMIT, PROJECT_AI_WORDING } from '../../../../../lib/appConstants';
import swal from 'sweetalert2';
import {
  DEFICIENCY_REVIEW_ACTIONS,
  buildDeficiencyTransactionPayload,
  processDeficiencyReviewTransaction,
} from './../../../../certfocus/transaction-logs/mappers';

import * as actions from './../../actions/actions';
import * as commonActions from './../../../../common/actions';
import * as certificateActions from './../../../../certfocus/certificates/actions';

class DeficiencyCoverageGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: ""
    };
  }

  dispatchConfirm = (id) => {
    const props = this.props;
    const local = props.local || {};
    const certificatesList = props.certificatesList || [];
    const deficiences = props.deficiences || [];
    const commonActions = props.commonActions;
    const actions = props.actions;
    const certificateActions = props.certificateActions;

    const certfocusStrings = 
      local.strings && local.strings.certfocusCertificates 
        ? local.strings.certfocusCertificates 
        : {};

    const confirmAttributeModelTitle = certfocusStrings.confirmAttributeModelTitle || '';
    const confirmAttributeModelText = certfocusStrings.confirmAttributeModelText || '';
    const confirmAttributeModelConfirmButtonText = certfocusStrings.confirmAttributeModelConfirmButtonText || 'OK';

    const projectInsuredID = 
      certificatesList[0] 
        ? certificatesList[0].ProjectInsuredID 
        : null;

    const deficienciesToConfirm = deficiences.filter(function(x) {
      return (
        x.ProjectInsuredDeficiencyID != null &&
        x.ProjectInsuredDeficiencyID === id &&
        x.AttributeStatus !== "Expired"
      );
    });

    if (deficienciesToConfirm.length > 0) {
      const transactionParams = {
        certificatesList,
        projectInsured: props.projectInsured,
        loginProfile: props.profile,
      };

      processDeficiencyReviewTransaction(
        buildDeficiencyTransactionPayload(transactionParams, deficienciesToConfirm, projectInsuredID),
        transactionParams,
        { action: DEFICIENCY_REVIEW_ACTIONS.CONFIRM_SINGLE }
      );
      commonActions.setLoading(true);
      var deficienciesRemaining = deficiences;

      actions.fetchConfirmDeficiences(
        deficienciesToConfirm,
        projectInsuredID,
        deficienciesRemaining,
        function() {
          certificateActions.fetchCertificates(projectInsuredID);
          actions.fetchDeficiences(projectInsuredID);
          certificateActions.fetchProjectInsured(projectInsuredID);
          commonActions.setLoading(false);
        }
      );
    } else {
      swal({
        title: confirmAttributeModelTitle,
        text: confirmAttributeModelText,
        confirmButtonText: confirmAttributeModelConfirmButtonText
      });
    }
  };

  dispatchWaive = (id) => {
    this.props.actions.setSelectWaiver(id);
    if (this.props.showWaivedModal) {
      this.props.showWaivedModal(DEFICIENCY_REVIEW_ACTIONS.WAIVE_SINGLE);
    }
  };

  dispatchConfirmCoverage = (coverageType) => {
    const props = this.props;
    const local = props.local || {};
    const certificatesList = props.certificatesList || [];
    const deficiences = props.deficiences || [];
    const commonActions = props.commonActions;
    const actions = props.actions;
    const certificateActions = props.certificateActions;

    const certfocusStrings = 
      local.strings && local.strings.certfocusCertificates 
        ? local.strings.certfocusCertificates 
        : {};

    const confirmAttributeModelTitle = certfocusStrings.confirmAttributeModelTitle || '';
    const confirmAttributeModelConfirmButtonText = certfocusStrings.confirmAttributeModelConfirmButtonText || 'OK';

    const projectInsuredID = 
      certificatesList[0] 
        ? certificatesList[0].ProjectInsuredID 
        : null;

    if (!projectInsuredID) {
      swal({
        title: "Error",
        text: "Missing project insured ID",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }
    // console.log(deficiences)
    const deficienciesToConfirm = deficiences.filter(function(x) {
      return (
        x.CoverageType === coverageType &&
        x.ProjectInsuredDeficiencyID != null &&
        x.AttributeStatus !== "Expired" &&
        [1, 2].includes(x.DefTypeID) &&
        [1, 2].indexOf(x.DeficiencyStatusID) === -1
      );
    });
    if (deficienciesToConfirm.length === 0) {
      const expiredAttributes = deficiences
        .filter(def => 
          def.CoverageType === coverageType && 
          def.AttributeStatus === "Expired" &&
          def.DefTypeID === props.defTypeId
        )
        .map(def => `${def.AttributeName}`);

      const expiredItemsHtml = expiredAttributes
        .map(attr => `<div style="margin: 8px 0 8px 12px; position: relative;">•&nbsp;&nbsp;${attr}</div>`)
        .join('');

      const expiredSection = expiredAttributes.length > 0 
        ? `
            <div style="text-align: left;">
              <strong style="color: #F04C41; display: block; margin: 12px 0 8px 0; font-size: 16px;">
                Expired: ${coverageType}
              </strong>
              <ul style="
                padding: 0 !important;
                list-style: disc outside !important;
                font-size: 14px;
                max-height: 220px;
                overflow-y: auto;
              ">
                ${expiredItemsHtml}
              </ul>
            </div>
          `
        : `<p style="color: #666; text-align: left; margin-top: 12px;">
              No expired attributes found in this coverage.
            </p>
          `;

      swal({
        title: confirmAttributeModelTitle,
        html: `
          <div>
            <div style="text-align: center; margin-bottom: 5px;">
              Policy Dates Must be Active!
            </div>
            ${expiredSection}
          </div>
        `,
        icon: "info",
        confirmButtonText: confirmAttributeModelConfirmButtonText
      });
      return;
    }

    swal({
      title: "Confirm!",
      showCancelButton: true,
      type: 'warning',
      html: 'Are you sure you want to Confirm all<br>"' + coverageType + '"?',
      icon: "success",
      button: "OK"
    }).then((willConfirm) => {
      if (!willConfirm || !willConfirm.value) return;

      const transactionParams = {
        certificatesList,
        projectInsured: props.projectInsured,
        loginProfile: props.profile,
      };

      processDeficiencyReviewTransaction(
        buildDeficiencyTransactionPayload(transactionParams, deficienciesToConfirm, projectInsuredID, { coverageType }),
        transactionParams,
        { action: DEFICIENCY_REVIEW_ACTIONS.CONFIRM_COVERAGE }
      );
      commonActions.setLoading(true);

      actions.fetchConfirmDeficiences(deficienciesToConfirm, projectInsuredID, deficiences, function(success) {
        certificateActions.fetchCertificates(projectInsuredID);
        actions.fetchDeficiences(projectInsuredID);
        certificateActions.fetchProjectInsured(projectInsuredID);
        commonActions.setLoading(false);        
      });
    });
  };

  dispatchUndo = (id) => {
    const props = this.props;
    const commonActions = props.commonActions;
    const actions = props.actions;
    const certificateActions = props.certificateActions;
    const certificatesList = props.certificatesList || [];
    const deficiences = props.deficiences || [];

    commonActions.setLoading(true);
    const projectInsuredID = 
      certificatesList[0] 
        ? certificatesList[0].ProjectInsuredID 
        : null;

    if (!projectInsuredID) return;

    const deficienciesToUnconfirm = deficiences.filter(function(def) {
      return def.ProjectInsuredDeficiencyID === id;
    });

    const transactionParams = {
      certificatesList,
      projectInsured: props.projectInsured,
      loginProfile: props.profile,
    };

    processDeficiencyReviewTransaction(
      buildDeficiencyTransactionPayload(transactionParams, deficienciesToUnconfirm, projectInsuredID),
      transactionParams,
      { action: DEFICIENCY_REVIEW_ACTIONS.UNCONFIRM_SINGLE }
    );

    actions.fetchUndoWaiverDeficiences(id, projectInsuredID, function() {
      certificateActions.fetchCertificates(projectInsuredID);
      actions.fetchDeficiences(projectInsuredID);
      certificateActions.fetchProjectInsured(projectInsuredID);
      commonActions.setLoading(false);
    });
  };

  dispatchUnconfirmCoverage = (coverageType) => {
    const props = this.props;
    const local = props.local || {};
    const certificatesList = props.certificatesList || [];
    const deficiences = props.deficiences || [];
    const commonActions = props.commonActions;
    const actions = props.actions;
    const certificateActions = props.certificateActions;

    const certfocusStrings = 
      local.strings && local.strings.certfocusCertificates 
        ? local.strings.certfocusCertificates 
        : {};

    const confirmAttributeModelTitle = certfocusStrings.confirmAttributeModelTitle || '';
    const confirmAttributeModelConfirmButtonText = certfocusStrings.confirmAttributeModelConfirmButtonText || 'OK';

    const projectInsuredID = 
      certificatesList[0] 
        ? certificatesList[0].ProjectInsuredID 
        : null;

    if (!projectInsuredID) {
      swal({
        title: "Error",
        text: "Missing project insured ID",
        icon: "error",
        confirmButtonText: "OK"
      });
      return;
    }
    // console.log(deficiences)
    const deficienciesToUnconfirm = deficiences.filter(function(x) {
      return (
        x.CoverageType === coverageType &&
        x.ProjectInsuredDeficiencyID != null &&
        x.DeficiencyStatusID === 1 &&
        x.DefTypeID !== 3
      );
    });

    if (deficienciesToUnconfirm.length === 0) {
      swal({
        title: confirmAttributeModelTitle,
        html: `No items to unconfirm for "${coverageType}".`,
        icon: "info",
        confirmButtonText: confirmAttributeModelConfirmButtonText
      });
      return;
    }

    const deficiencyIds = deficienciesToUnconfirm.map(function(def) {
      return def.ProjectInsuredDeficiencyID;
    });

    swal({
      title: "Unconfirm!",
      showCancelButton: true,
      type: 'warning',
      html: 'Are you sure you want to Unconfirm all<br>"' + coverageType + '"?',
      icon: "warning",
      button: "OK!"
    }).then((willUnconfirm) => {
      if (!willUnconfirm || !willUnconfirm.value) return;

      const transactionParams = {
        certificatesList,
        projectInsured: props.projectInsured,
        loginProfile: props.profile,
      };

      processDeficiencyReviewTransaction(
        buildDeficiencyTransactionPayload(transactionParams, deficienciesToUnconfirm, projectInsuredID, { coverageType }),
        transactionParams,
        { action: DEFICIENCY_REVIEW_ACTIONS.UNCONFIRM_COVERAGE }
      );
      commonActions.setLoading(true);

      actions.fetchUndoWaiverDeficiences(deficiencyIds, projectInsuredID, function(success) {
        certificateActions.fetchCertificates(projectInsuredID);
        actions.fetchDeficiences(projectInsuredID);
        certificateActions.fetchProjectInsured(projectInsuredID);
        commonActions.setLoading(false);    
      });
    });
  };

  getFilteredDeficiencies() {
    const deficiences = this.props.deficiences || [];
    const type = this.props.type || 'pending';
    const defTypeId = this.props.defTypeId;

    if (type === 'accepted') {
      return deficiences.filter(function(def) {
        return def.DeficiencyStatusID === 1 && def.DefTypeID !== 3;
      });
    }

    // pending mode (Major/Minor)
    const excludeStatuses = [1, 2];
    return deficiences.filter(function(def) {
      return (
        def.DefTypeID === defTypeId &&
        excludeStatuses.indexOf(def.DeficiencyStatusID) === -1
      );
    });
  }

  renderSectionContent = (deficiences) => {
    const isArchived = this.props.isArchived;
    const AIWording = this.props.AIWording || '';
    const type = this.props.type || 'pending';
    const isAcceptedMode = type === 'accepted';

    if (!deficiences || !Array.isArray(deficiences) || deficiences.length === 0) {
      return <span className="d-flex justify-content-center align-items-center mt-2">No results</span>;
    }

    const groups = {};
    deficiences.forEach(function(def) {
      const key = def.CoverageType || 'Other';
      if (!groups[key]) groups[key] = [];
      groups[key].push(def);
    });

    var _this = this;

    return (
      <div className="coverage-sections">
        <table className="table table-deficiencies-header mb-0">
          <thead className="thead-light">
            <tr>
              <th className="coverage-name">Coverage</th>
              <th className="coverage-expiration-date">Expire Date</th>
              <th className="coverage-attribute">Attribute</th>
              <th className="coverage-required">Required</th>
              <th className="coverage-provided">Provided</th>
              {!isAcceptedMode && <th className="coverage-status">Status</th>}
              <th className="coverage-actions"></th>
            </tr>
          </thead>
        </table>

        {Object.keys(groups).map(function(coverageType) {
          const defs = groups[coverageType];

          return (
            <div key={coverageType} className="coverage-group mb-1 border rounded bg-white">
              <div className="coverage-header d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
                <h5 className="coverage-title mb-0 font-black">{coverageType}</h5>
                <RolAccess
                  masterTab="certificates_insurance"
                  sectionTab="edit_certificate"
                  component={function() {
                    if (isAcceptedMode) {
                      const hasUndoable = defs.some(function(def) {
                        return def.ProjectInsuredDeficiencyID;
                      }) && defs.length > 0;
                      if (!isArchived && hasUndoable) {
                        return (
                          <button
                            className="nav-btn undo-coverage-btn"
                            onClick={function() {
                              _this.dispatchUnconfirmCoverage(coverageType);
                            }}
                          >
                            Unconfirm Coverage
                          </button>
                        );
                      }
                      return null;
                    }

                    return (
                      <button
                        className="nav-btn confirm-coverage-btn"
                        onClick={function() {
                          _this.dispatchConfirmCoverage(coverageType);
                        }}
                      >
                        Confirm Coverage
                      </button>
                    );
                  }}
                />
              </div>

              <table className="table table-deficiencies mb-0">
                <tbody>
                  {defs.map(function(def, index) {
                    const defDate = def.ExpirationDate ? new Date(def.ExpirationDate).getTime() : null;
                    const currentDate = new Date().getTime();
                    const hasExpired = defDate && currentDate >= defDate;

                    return (
                      <tr key={index} className="coverages">
                        <td className="coverage-name">{def.CoverageType}</td>
                        <td className="coverage-expiration-date">
                          <span style={{ color: hasExpired ? '#F04C41' : '#8CC739' }}>
                            {def.ExpirationDate ? moment.utc(def.ExpirationDate).format('MM/DD/YYYY') : ''}
                          </span>
                        </td>
                        <td className="coverage-attribute">
                          <div>{def.AttributeName}</div>
                          <div style={{ fontSize: 10, marginTop: 4 }}>
                            {def.AttributeName && 
                             def.AttributeName.toLowerCase().indexOf(PROJECT_AI_WORDING.toLowerCase()) !== -1
                              ? AIWording
                              : (def.DeficiencyText || '')}
                          </div>
                        </td>
                        <td className="coverage-required">
                          <DisplayTextWithConditionalModal
                            string={def.ConditionValue}
                            displayTextLimit={TEXT_DISPLAY_LIMIT.HUNDRED}
                          />
                        </td>
                        <td className="coverage-provided">
                          <DisplayTextWithConditionalModal
                            string={def.AttributeValue}
                            displayTextLimit={TEXT_DISPLAY_LIMIT.HUNDRED}
                          />
                        </td>
                        {!isAcceptedMode && <td className="coverage-status">{def.AttributeStatus}</td>}
                        <td className="coverage-actions">
                          <RolAccess
                            masterTab="certificates_insurance"
                            sectionTab="edit_certificate"
                            component={function() {
                              return isAcceptedMode
                                ? _this.renderDeficiencyUndo(def, isArchived)
                                : _this.renderDeficiencyActions(def, isArchived);
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  };

  renderDeficiencyActions = (def, isArchived) => {
    if (isArchived) return null;

    return (
      <td>
        <a
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => this.dispatchConfirm(def.ProjectInsuredDeficiencyID)}
        >
          Confirm
        </a>
        <br />
        <a
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => this.dispatchWaive(def.ProjectInsuredDeficiencyID)}
        >
          Waive
        </a>
      </td>
    );
  };

  renderDeficiencyUndo = (def, isArchived) => {
    if (isArchived || !def.ProjectInsuredDeficiencyID) return null;

    return (
      <td>
        <a
          style={{ color: "blue", cursor: "pointer" }}
          onClick={() => this.dispatchUndo(def.ProjectInsuredDeficiencyID)}
        >
          Undo
        </a>
      </td>
    );
  };

  render() {
    const title = this.props.title ;
    const isInitiallyOpen = this.props.type === 'accepted' ? false : (this.props.showAll || this.props.firstView);

    const filteredDeficiencies = this.getFilteredDeficiencies();

    const accordionTitle = (
      <span className="accordionHeader d-flex justify-content-center deficiency-menu-item">
        <span className="mt-2">
          <h5>{title}</h5>
        </span>
      </span>
    );

    const data = [{
      title: accordionTitle,
      content: this.renderSectionContent(filteredDeficiencies),
      isShown: isInitiallyOpen
    }];

    const headerStyle = {
      background: 'linear-gradient(to bottom right, #7ED0BC, #29AEA2)',
      color: '#FFFFFF',
      paddingTop: '5px',
      paddingBottom: '5px'
    };

    return (
      <div className="p-2" style={{ width: '100%' }}>
        <Accordion
          data={data}
          headerStyle={headerStyle}
        />
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    deficiences: (state.deficiences && state.deficiences.deficiencesList) || [],
    certificatesList: (state.certificates && state.certificates.certificatesList) || [],
    projectInsured: (state.certificates && state.certificates.projectInsured) || null,
    profile: (state.login && state.login.profile) || null,
    showAll: (state.deficiences && state.deficiences.showAll) || false,
    firstView: (state.deficiences && state.deficiences.firstView) || false,
    local: state.localization || {},
  };
};

const mapDispatchToProps = function(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    certificateActions: bindActionCreators(certificateActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeficiencyCoverageGroup);